import { FC, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import classNames from 'classnames';

import OdometerGaugeGraph from '@/components/graphs/odometer-gauge-graph/OdometerGaugeGraph';
import styles from '@/components/settings-workshops/SettingsWorkshopPlan.module.css';
import { FabricCanvas } from '@/components/ui/FabricCanvas';
import { Medium } from '@/constants/mediums';
import { useFabricCanvas } from '@/hooks/useFabricCanvas';
import { Odometer } from '@/pages/electricity-workshop-page/Odometer';

interface PlanProps {
  plan: string;
}

export const Plan: FC<PlanProps> = ({plan}) => {
  const [open, setOpen] = useState(false);
  const { canvasRef, editor, selectedObjects } = useFabricCanvas();

  const planJSON: any = JSON.parse(plan);

  useEffect(() => {
    editor?.canvas?.loadFromJSON(planJSON, () => {
      editor?.canvas?.renderAll();
      editor?.canvas?.forEachObject((object) => {
        if (object.type === 'rect') {
          editor?.canvas?.remove(object);
        }
        object.selectable = false;
      })
      editor?.canvas?.renderAll();
    });
  }, [plan, editor?.canvas]);

  return <>
    <div style={{position: 'relative'}}>
      <FabricCanvas ref={canvasRef} className={classNames(styles.canvasReadonly)} />
      {
        planJSON?.objects?.filter((object: any) => object.type === 'rect' && object.data.value > 0).map((object: any) => (
          <div key={object.data.value} style={{position: 'absolute', left: object.left, top: object.top}}>
            <Odometer key={`${object.data.value  }-${  object.top}`} id={object.data.value} onClick={() => setOpen(true)} />
          </div>
        ))
      }
    </div>

    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Detail elektroměru</DialogTitle>
      <OdometerGaugeGraph
        consumption={11.3}
        maxConsumption={1}
        totalConsumption={0}
        lastThreeMonthData={[]}
        linkToDetail="/energy/electricity/readings/39"
        title=""
        medium={Medium.electricity}
      />
    </Dialog>
  </>
};
